import {
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
  DialogContent,
  Dialog,
} from '@mui/material';

import { TDocument } from '@/types/document';

import LoadingButton from '@/@mantis/components/@extended/LoadingButton';
import { Trash01Icon } from '@/assets/icons/Trash01Icon';

interface Props {
  document: TDocument;
  onClose: () => void;
  onDocumentDeleted: () => void;
  isDeleting?: boolean;
}

const DocumentDeleteModal: React.FC<Props> = ({
  document,
  onClose,
  onDocumentDeleted,
  isDeleting = false,
}) => (
  <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Confirm Deletion</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete {document.original_name} document?
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>

      <LoadingButton
        variant="contained"
        color="error"
        startIcon={<Trash01Icon />}
        loading={isDeleting}
        onClick={onDocumentDeleted}
      >
        Delete
      </LoadingButton>
    </DialogActions>
  </Dialog>
);

export default DocumentDeleteModal;
